import {
  collection,
  getDocs,
  query,
  where,
  orderBy
} from 'firebase/firestore';
import { db } from './firebase/config';

const COLLECTION = 'testimonials';

export const testimonialsService = {
  /**
   * Get all visible testimonials for public website
   */
  async getVisibleTestimonials() {
    try {
      const q = query(
        collection(db, COLLECTION),
        where('visible', '==', true),
        orderBy('createdAt', 'desc')
      );

      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      // Return fallback data if Firebase fails
      return [
        {
          id: 1,
          text: "Kirstie's Reiki session was transformative. I felt lighter, more grounded, and deeply peaceful. The combination of crystals and aromatherapy created a truly healing experience.",
          name: "Sarah M.",
          rating: 5,
          source: 'manual'
        },
        {
          id: 2,
          text: "The tarot reading with Kirstie was incredibly accurate and uplifting. She helped me see patterns I was blind to and gave me the confidence to make important life changes.",
          name: "Emma R.",
          rating: 5,
          source: 'manual'
        },
        {
          id: 3,
          text: "Working with Kirstie through soul coaching changed my life. She helped me uncover the root of my struggles and gave me practical tools to create lasting change.",
          name: "Lisa T.",
          rating: 5,
          source: 'manual'
        }
      ];
    }
  },

  /**
   * Get featured testimonials (limited number for homepage)
   */
  async getFeatured(limit = 3) {
    const testimonials = await this.getVisibleTestimonials();
    return testimonials.slice(0, limit);
  }
};

export default testimonialsService;
